import React from "react";
import "./FullPageSpinner.css";

const FullPageSpinner = () => {
  return (
    <div className="fullpage-spinner" aria-live="polite" aria-label="Cargando">
      <div className="spinner" />
    </div>
  );
};

export default FullPageSpinner;

